import { AppVersionEntityModel } from "src/store/models/entity/appVersion/entity";
import { AppVersionHelperModel } from "src/store/models/entity/appVersion/helper";
import { AppVersionListModel } from "src/store/models/entity/appVersion/list";

export const encooAppVersionModels = {
  entity: AppVersionEntityModel,
  helper: AppVersionHelperModel,
  list: AppVersionListModel,
};
